$(document).on('click', '.hamburger', function() {
  $('.Navigation').toggleClass('is-active');
  $(this).toggleClass('is-active');
});
